/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcExportToPdf
 * @restrict E
 * @description
 * The wcExportToPdf directive is responsible for export the whole table to PDF.
 *
 * This directive has a requirement that
 */


angular.module('WebCoreModule').directive('wcExportToPdf', ['pdfMake', 'WcTranslateConfiguratorService', '$filter', '_', function (pdfMake, WcTranslateConfiguratorService, $filter ,_) {
    return {
		restrict: 'E',
        template: '<button type="button" class="btn icon icon-pdf" ng-click="exportToPdfController.makePDF()" aria-label="{{"exportTo.pdfButtonAriaLabel" | translate}}"><i class="fa fa-file-pdf-o" aria-hidden="true" title="{{"exportTo.pdfButtonTitle" | translate}}"></i><span class="hidden-xs">{{"exportTo.pdfButtonText" | translate}}</span></button>',
		replace: true,
		require: ['wcExportToPdf'],
		scope: {},
		controllerAs: 'exportToPdfController',
		controller: ['$scope', '$element', '_', function ($scope, $element, _) {
            WcTranslateConfiguratorService.loadPartAndRefresh('WC-dataTable');

			var responsiveTableController = $element.parent().controller('wcResponsiveTable');
			responsiveTableController = responsiveTableController || $scope.responsiveTableController || $scope.$parent.responsiveTableController;

            this.exportToPDF = function (tableheaders, locationInCollection, tableId) {

                var collection = responsiveTableController.WcTableCollectionService.getCollection();
                var collectionLength= collection.length; //number of rows
                var outputTDLength =  tableheaders.length; //number of columns you want in the pdf


                var tableContent = [];
                var rowContent = [];
                var columnContent = "";

                //header formatting
                for (var i = 0; i<outputTDLength; i++){
                    tableheaders[i] = {text: tableheaders[i],  bold: true};//making the title bold
                }
                tableContent.push(tableheaders);

                //pdf table formatting
                var pdfTableBodyFormatting = [];
                for (var x= 0; x<outputTDLength; x++){
                    pdfTableBodyFormatting.push("auto");
                }

                if(collectionLength>0) {
                    for (var i = 0; i < collectionLength; i++) {
                        var row = collection[i];
                        for (var j = 0; j < outputTDLength; j++) {
                            var str = locationInCollection[j].toString();
                            if (str.indexOf('.') == -1) { // . not found
                                columnContent = row[locationInCollection[j]];
                            } else {
                                var stringArr = str.split(".");
                                var innerTxt = row;

                                for (var k = 0; k < stringArr.length; k++) {
                                    innerTxt = innerTxt[stringArr[k]];
                                }
                                columnContent = innerTxt;
                            }
                            if(columnContent) {
                                if(_.isDate(columnContent)){
                                    rowContent.push($filter('date')(columnContent,'yyyy-MM-dd'));
                                }else {
                                    rowContent.push(columnContent.toString());
                                }
                           } else {
                                rowContent.push("");
                            }

                        }
                        tableContent.push(rowContent);
                        rowContent = [];
                    }
                }
                var docDefinition = {
                    content: [
                        {
                            table: {
                                // headers are automatically repeated if the table spans over multiple pages
                                // you can declare how many rows should be treated as headers
                                headerRows: 1,
                                widths: pdfTableBodyFormatting,

                                body: tableContent
                            }
                        }
                    ]
                }; //end doc def
                tableId = tableId.toString() + ".pdf";
                return pdfMake.createPdf(docDefinition).download(tableId);
            };

			this.makePDF =  function() {

				//get table headers
				var tableId = responsiveTableController.id;

                var tableHeader = $(responsiveTableController.table).find('th');
				//var tableHeader = $element.parent().children('table').children('thead').children('tr').children('th');
				var tableHeadersArray = [];

				for (var i = 0; i < tableHeader.length; i++) {
				    var text = $(tableHeader[i]).find('.header-text').text();
					if (text !== "Actions" && text.trim() !== "" ) {
						tableHeadersArray.push(text);
					}
				}

				//get table ng-bind
				var tableBodyArray = [];
				var bodyLength = responsiveTableController.WcTableCollectionService.getCollection().length;

				if (bodyLength > 0) {
                    var td = $(responsiveTableController.table).find('tbody tr:first-child td');
					//var tableRow = $element.parent().children('table').children('tbody').children('tr');

					for (var j = 0; j < td.length; j++) {

						if (td[j].getAttribute("ng-bind")) { //.getAttribute("ng-bind") returns row.region
							var fullStr = td[j].getAttribute("ng-bind");
							var substring = fullStr.substr(fullStr.indexOf('.') + 1); //this gets string after the period
							tableBodyArray.push(substring);
						}
						else if (tableHeader[j].getAttribute("wc-column-sort")) {
							tableBodyArray.push(tableHeader[j].getAttribute("wc-column-sort"));
						}

					}
				}
				this.exportToPDF(tableHeadersArray, tableBodyArray, tableId);
			};
		}]
    };
}]);
